import React from "react";
import { useGetVillesQuery } from "redux_dir/features/villeApi";

/**
 * Composant de sélection de ville
 */
const VilleSelect = ({ value, isEditing, register, error }) => {
  const { data: villesResponse, isLoading } = useGetVillesQuery();
  
  // Extraire les villes (peut être dans data.data ou directement data)
  const villes = villesResponse?.data || villesResponse || [];

  if (!isEditing) {
    return (
      <div className="mb-4">
        <label className="block text-sm font-medium text-gray-700 mb-2">
          Ville
        </label>
        <p className="text-gray-800 py-2">
          {value || "-"}
        </p>
      </div>
    );
  }

  return (
    <div className="mb-4">
      <label className="block text-sm font-medium text-gray-700 mb-2">
        Ville
      </label>
      {isLoading ? (
        <div className="w-full px-4 py-2 border border-gray-300 rounded-lg bg-gray-50">
          Chargement des villes...
        </div>
      ) : (
        <>
          <select
            {...register}
            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent bg-white"
          >
            <option value="">Sélectionnez une ville</option>
            {villes.map((ville) => (
              <option key={ville.id} value={ville.id}>
                {ville.name}
              </option>
            ))}
          </select>
          {error && (
            <p className="text-red-500 text-sm mt-1">{error.message}</p>
          )}
        </>
      )}
    </div>
  );
};

export default VilleSelect;
